import { useSelector } from "react-redux";
import { Alert } from "react-bootstrap";
import { selectCheckoutJob, selectIsCurrentUserOwner } from "../../redux/slices/checkoutSlice";

const isTruthyCheckedOut = (value) =>
  value === true ||
  value === 1 ||
  String(value || "").trim().toLowerCase() === "true" ||
  String(value || "").trim().toLowerCase() === "yes";

const CheckoutNotification = ({ currentUser }) => {
  const jobCheckoutStatus = useSelector(selectCheckoutJob);
  const isCurrentUserOwner = useSelector(selectIsCurrentUserOwner);
  const isJobCheckedOut = isTruthyCheckedOut(jobCheckoutStatus?.IsCheckedOut);
  
  // Determine if we need to show the notification
  const showCheckoutNotification = isJobCheckedOut && !isCurrentUserOwner;

  return (
    <>
      {showCheckoutNotification && (
        <Alert variant="warning" className="mb-3">
          This job is currently checked out by {jobCheckoutStatus?.CheckedOutBy}.
        </Alert>
      )}
    </>
  );
};

export default CheckoutNotification;
